import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import Spoiler from "../../../user_content/spoiler";

export default GrComponentFactory.createClass({
  displayName: "ReaderQuestionDetails",

  propTypes: GrPropTypes.communityQuestion(),

  renderQuestionSpoilerWarning() {
    return (
      <span className="communityQANewsfeedItem__spoilerWarning">
        This question contains spoilers…
      </span>
    );
  },

  renderQuestionText() {
    if (this.props.isSpoiler) {
      return <Spoiler spoilerWarning={this.renderQuestionSpoilerWarning()}>
              {this.props.questionText}
             </Spoiler>;
    } else {
      return this.props.questionText;
    }
  },

  renderAnswerButton() {
    return <a className="gr-button u-marginTopMedium u-marginBottomMedium"
              href={this.props.questionUrl}>
              Answer this question
            </a>;
  },

  render() {
    return (
      <div className="gr-newsfeedItem__details">
        <div className="u-defaultType">
          {this.renderQuestionText()}
        </div>
        {this.renderAnswerButton()}
      </div>
    );
  },
});
